'use strict'

var _ = require('lodash')

var EditNewController = require('src/components/edit_new-controller.js')
var Tabs = require('src/behaviors/tabs')
var App = require('app')

var View = require('./view.js')
var DialogModel = require('src/common/dialog-model.js')

var GroupEdit = function (options) {
  var Controller = EditNewController.extend({
    initialize: function (options) {
      var self = this
      this.region = options.region
      var limitNrDevices = 10000;
      // tabs
      var groups = options.collection
      var group = options.model
      // self.client = options.client
      if (!group) group = App.globalChannel.request('group:entity:new')
      if (group.isNew()) group.set('client', self.options.client.get('_id'))

      // define the dialog model
      var dialogModel = new DialogModel({
        title:'group',
        buttons:{
          left:[
            { label:'delete', icon:true, slug:'delete', action:'dialog:delete', roles: ['super','admin'] }
          ],
          right:[
            { label:'cancel', slug:'cancel', action:'dialog:close', roles: ['super','admin'] },
            { label:'save', primary:true, slug:'save', action:'dialog:submit', roles: ['super','admin'] }
          ]
        }
      })

      // prepare the group lists
      this.groupSelectableDevices = App.globalChannel.request('device:entities', {
        query: {
          'type': group.get('type'),
          'client': group.get('client'),
          '$select': 'name',
          '$limit': limitNrDevices
        },
        pagination: false,
        noFetch: group.isNew()
      })

      // if this is a new group, create an empty 'devices list' because the device
      // doesn't have any devices yet
      if (group.isNew()) {
        // filter collection
        var ListDevicesCollection = Backbone.Collection.extend({ model: Backbone.Model.extend({})})
        this.groupListDevices = new ListDevicesCollection()
      } else {
        this.groupListDevices = App.globalChannel.request('device:entities', {
          query: {
            'groups': group.get('_id'),
            '$select': 'name',
            '$limit': limitNrDevices
          }
        })
      }

      //
      this.view = this.getView(dialogModel, group, groups)
      // listen
      this.listenTo(this.view, 'dialog:submit', this.formSubmit)
      this.listenTo(this.view, 'dialog:delete', this.onDelete)

      this.listenTo(this.view, 'childview:filter-change', function (value) {
        self.groupSelectableDevices.filterBy({name: value})
      })
      this.listenTo(this.view, 'childview:group:type-change', function (data) {

        // fetch the devices by type
        self.groupSelectableDevices.fetch(
          {
            data: {
              'type': group.get('type'),
              'client': group.get('client'),
              '$select': 'name',
              '$limit': limitNrDevices
            },
            reset: true
          }
        )

        // reset the selected devices
        self.groupListDevices.reset()

      })
      this.listenTo(this.view, 'childview:render', function (view) {
        self.availableDevicesRegion(view, group)
        self.selectedDevicesRegion(view, group)
      })

      this.region.show(this.view)
    },
    onDeleteMessage: function (model, message) {
      return 'Are you sure you want to delete the group "' + model.get('name') + '"?'
    },
    formSubmit: function (data) {
      var self = this
      var data = Backbone.Syphon.serialize(this.view)

      // selected devices
      data.devices = this.groupListDevices.toJSON()

      // // delete data.devices
      this.processFormSubmit(data, this.view.model, this.view.collection, function () {
        self.region.empty()
      })
    },

    availableDevicesRegion: function (view, group) {
      var self = this

      var devicesListView = self.getDevicesListView(self.groupSelectableDevices.filtered, group, 'available-devices')

      // when the groupListDevices change update the selectable devices list as well.
      // this is tied together. This is called on initial load of the collection as well.
      self.listenTo(self.groupListDevices, 'reset add remove', function () {
        self.groupSelectableDevices.remove(self.groupListDevices.toJSON())
      })

      // when add-devices is clicked
      self.listenTo(self.view, 'childview:add-devices', function () {

        var selectedDevices = self.groupSelectableDevices.filtered.where({'selected': true})
        // remove selected state
        _.forEach(selectedDevices, function (device) {
          device.set('selected', false)
        })

        //
        self.groupListDevices.add(selectedDevices)
      // self.groupSelectableDevices.remove(selectedDevices)
      })

      self.listenTo(self.view, 'childview:select-all-available', function (view, toggle) {
        self.groupSelectableDevices.filtered.each(function (model) {
          model.set('selected', toggle)
        })
      })
      self.listenTo(self.view, 'childview:select-all-attached', function (view, toggle) {
        self.groupListDevices.filtered.each(function (model) {
          model.set('selected', toggle)
        })
      })

      view.showChildView('availableDevicesRegion', devicesListView)
    },
    selectedDevicesRegion: function (view, group) {
      var self = this

      var devicesListView = self.getDevicesListView(self.groupListDevices, group, 'attached-devices')

      self.listenTo(self.view, 'childview:remove-devices', function (data) {
        var selectedDevices = self.groupListDevices.where({'selected': true})

        // remove selected state
        _.forEach(selectedDevices, function (device) {
          device.set('selected', false)
        })
        self.groupListDevices.remove(selectedDevices)
        self.groupSelectableDevices.add(selectedDevices)
      })

      view.showChildView('selectedDevicesRegion', devicesListView)
    },

    getDevicesListView: function (devices, group, type) {
      return new View.DevicesListView({
        collection: devices,
        group: group,
        type:type
      })
    },
    getView: function (dialogModel, client, collection) {
      return new View.Layout({
        model: client,
        collection: collection,
        dialogModel:dialogModel
      })
    }
  })

  return new Controller(options)
}

module.exports = GroupEdit



// WEBPACK FOOTER //
// ./js/modules/groups/edit-new/index.js